(function(){
  var LIME = "#ccff33";
  var CSS = [
    ".rp-swatched{display:flex !important;flex-wrap:wrap !important;align-items:center;gap:0}",
    ".rp-swatched legend,.rp-swatched .form__label{flex:0 0 100% !important;width:100% !important;margin-bottom:2px;font-size:12px;color:#7c7c7c;font-weight:600}",
    ".rp-swatched .rp-selcolor{flex:0 0 100% !important;width:100% !important;font-size:16px;font-weight:800;color:#111;letter-spacing:-.01em;margin-bottom:13px;min-height:19px}",
    ".rp-swatched .variant-option__button-label{display:inline-flex !important;align-items:center;justify-content:center;border:0 !important;background:none !important;box-shadow:none !important;outline:none !important;padding:0 !important;margin:0 11px 6px 0 !important;width:62px !important;height:62px !important;min-width:0 !important;min-height:0 !important;border-radius:50% !important;cursor:pointer}",
    ".rp-swatched .variant-option__button-label__pill,.rp-swatched .variant-option__button-label__text{display:none !important}",
    ".rp-swatched .variant-option__button-label::before,.rp-swatched .variant-option__button-label::after{display:none !important}",
    ".rp-swatched .rp-pastille{width:62px;height:62px;border-radius:50%;background:#f4f4f2;background-size:cover;background-position:center;background-repeat:no-repeat;border:1px solid #d5d5d5;display:block;transition:border-color .15s,box-shadow .15s}",
    ".rp-swatched .variant-option__button-label.rp-on .rp-pastille{border-color:#111;box-shadow:0 0 0 2px "+LIME+"}",
    ".rp-swatched input{position:absolute !important;opacity:0 !important;width:1px !important;height:1px !important;pointer-events:none}"
  ].join("");
  function injectCSS(){
    if(document.getElementById("rp-swatch-css")) return;
    var st = document.createElement("style");
    st.id = "rp-swatch-css";
    st.textContent = CSS;
    (document.head||document.documentElement).appendChild(st);
  }
  function handle(){ var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? m[1] : ""; }
  var MAP = null;
  function loadMap(cb){
    if(MAP){ cb(); return; }
    var h = handle();
    if(!h){ MAP = {}; cb(); return; }
    fetch("/products/" + h + ".js", {credentials:"same-origin"}).then(function(r){ return r.json(); }).then(function(p){
      var ci = -1;
      for(var i=0;i<p.options.length;i++){
        var nm = typeof p.options[i] === "string" ? p.options[i] : (p.options[i] && p.options[i].name);
        if(/couleur|color/i.test(nm || "")) ci = i;
      }
      MAP = {};
      for(var j=0;j<p.variants.length;j++){
        var v = p.variants[j];
        var color = ci >= 0 ? v.options[ci] : v.options[0];
        var img = v.featured_image ? v.featured_image.src : null;
        if(color && img && !MAP[color]) MAP[color] = img;
      }
      cb();
    }).catch(function(){ MAP = MAP || {}; cb(); });
  }
  function colorGroup(){
    var vp = document.querySelector("variant-picker");
    if(!vp) return null;
    var groups = vp.querySelectorAll(".variant-option");
    for(var i=0;i<groups.length;i++){
      var lg = groups[i].querySelector("legend, .form__label");
      if(lg && /couleur|color/i.test(lg.textContent || "")) return groups[i];
    }
    return null;
  }
  function checkedValue(g){
    var inp = g.querySelector("input:checked");
    return inp ? (inp.value || "") : "";
  }
  function syncSel(g){
    var labels = g.querySelectorAll(".variant-option__button-label");
    for(var i=0;i<labels.length;i++){
      var inp = labels[i].querySelector("input[type=radio]");
      if(inp && inp.checked) labels[i].classList.add("rp-on");
      else labels[i].classList.remove("rp-on");
    }
    var sel = g.querySelector(".rp-selcolor");
    if(sel) sel.textContent = checkedValue(g);
  }
  function decorate(g){
    var legend = g.querySelector("legend, .form__label");
    if(legend && !g.querySelector(".rp-selcolor")){
      var sc = document.createElement("div");
      sc.className = "rp-selcolor";
      legend.insertAdjacentElement("afterend", sc);
    }
    var labels = g.querySelectorAll(".variant-option__button-label");
    for(var i=0;i<labels.length;i++){
      var lbl = labels[i];
      if(lbl.querySelector(".rp-pastille")) continue;
      var inp = lbl.querySelector("input[type=radio]");
      var val = inp ? (inp.value || "") : "";
      var img = MAP && MAP[val] ? MAP[val] : null;
      var pas = document.createElement("span");
      pas.className = "rp-pastille";
      if(img) pas.style.backgroundImage = "url(" + img + ")";
      lbl.insertBefore(pas, lbl.firstChild);
    }
  }
  function build(){
    var g = colorGroup();
    if(!g) return;
    injectCSS();
    if(g.classList.contains("rp-swatched")){ syncSel(g); return; }
    loadMap(function(){
      var gg = colorGroup();
      if(!gg || gg.classList.contains("rp-swatched")) return;
      gg.classList.add("rp-swatched");
      decorate(gg);
      syncSel(gg);
      gg.addEventListener("change", function(){ syncSel(gg); });
    });
  }
  function boot(){
    build();
    document.addEventListener("change", function(e){
      if(e.target && e.target.closest && e.target.closest("variant-picker")){
        var g = colorGroup();
        if(g && g.classList.contains("rp-swatched")) syncSel(g);
      }
    }, true);
    if(window.MutationObserver){
      var scheduled = false;
      var obs = new MutationObserver(function(){
        if(scheduled) return;
        scheduled = true;
        window.setTimeout(function(){ scheduled = false; build(); }, 120);
      });
      obs.observe(document.documentElement, {childList:true, subtree:true});
    }
    var n = 0;
    var iv = window.setInterval(function(){ build(); n++; if(n > 24) window.clearInterval(iv); }, 500);
  }
  if(document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
})();
